import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as tiledPromoActions from '../../../actions/tiledPromos';
import DeleteModal from '../DeleteModal';

const propTypes = {
  data: PropTypes.object.isRequired,
  deleteTiledPromo: PropTypes.func.isRequired
};

const DeleteMisc2Modal = ({ data, deleteTiledPromo, ...props }) => (
  <DeleteModal
    id="delete-misc-modal"
    title="Misc2"
    itemTitle={data.title}
    deleteItem={() => deleteTiledPromo(data.hotelId, data.id)}
    {...props}
  />
);

DeleteMisc2Modal.propTypes = propTypes;

export default connect(null, tiledPromoActions)(DeleteMisc2Modal);
